import { useContext } from 'react';

import { ChartProvider } from '@/components/Chart/context/ChartContext';
import useUserDetails from '@/hooks/useUserDetails';
import DataHubChart from '@/pages/DataHub/Chart/DataHubChart';
import EmptyDataHubScreen from '@/pages/DataHub/EmptyDataHubScreen';
import DataHubExport from '@/pages/DataHub/Export';
import DataHubPreview from '@/pages/DataHub/Preview';
import DataHubSummary from '@/pages/DataHub/Summary';
import { DataHub } from 'types/dataHub';

import { NavigationContext } from '../NavigationContext';

interface TabPanelContentProps {
  activeTab: number;
  status: string;
  activeDataHub: DataHub | null | undefined;
}

const TabPanelContent = ({ activeTab, status, activeDataHub }: TabPanelContentProps) => {
  const { navigateToDataHub } = useContext(NavigationContext);
  const { isUserBasic, isUserExpired } = useUserDetails();

  if (
    status !== 'loading' &&
    (!activeDataHub || activeDataHub.symbols.length < 1) &&
    !(isUserBasic || isUserExpired)
  ) {
    return <EmptyDataHubScreen />;
  }

  switch (activeTab) {
    case 1:
      return <DataHubPreview />;
    case 2:
      return (
        <ChartProvider>
          <DataHubChart />
        </ChartProvider>
      );
    case 3:
      return <DataHubExport />;
    default:
      return (
        <ChartProvider>
          <DataHubSummary navigateToDataHub={navigateToDataHub} />
        </ChartProvider>
      );
  }
};

export default TabPanelContent;
